import { render, staticRenderFns } from "./DasmMenu.vue?vue&type=template&id=088783e3&scoped=true&"
import script from "./DasmMenu.vue?vue&type=script&lang=js&"
export * from "./DasmMenu.vue?vue&type=script&lang=js&"
import style0 from "./DasmMenu.vue?vue&type=style&index=0&id=088783e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088783e3",
  null
  
)

export default component.exports